"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      console.error("App error:", error);
    }
  }, [error]);

  return (
    <div className="flex min-h-[80vh] flex-col items-start gap-4 px-6 py-12">
      <div className="space-y-2">
        <h2 className="text-3xl font-bold">Something went wrong</h2>
        <p className="text-muted-foreground">
          Please try again or refresh the page.
        </p>
      </div>
      <Button onClick={() => reset()}>Try again</Button>
    </div>
  );
}
